module.exports = __webpack_public_path__ + "static/img/4.efafe144.png";